import React from 'react';

type PhoneNumber = {
  phoneNumber: string;
  dfn: string;
};

export function PhoneNumber({ phoneNumber, dfn }: PhoneNumber) {
  return (
    <p>
      <dfn className="invisible">{dfn}: </dfn>
      {phoneNumber}
    </p>
  );
}
